import type { AnnotationColor } from "./annotation";

export const APPLICATION_SETTINGS_KEY = "application" as const;

export type SettingsRecord = {
  key: typeof APPLICATION_SETTINGS_KEY;
  value: {
    schemaVersion: 1;
    keepPdfByDefault: boolean;
    highlightColor: AnnotationColor;
    reducedMotionOverride: "system" | "reduce" | "allow";
  };
};

export const DEFAULT_SETTINGS: SettingsRecord = {
  key: APPLICATION_SETTINGS_KEY,
  value: {
    schemaVersion: 1,
    keepPdfByDefault: false,
    highlightColor: "yellow",
    reducedMotionOverride: "system",
  },
};
